import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { lazy } from 'react';

const NoticeDetailPage = lazy(() => import('./NoticeDetailPage'));

const NoticeDetailRoute: FuseRouteItemType = {
	path: 'notices/:noticeId',
	element: <NoticeDetailPage />,
	settings: {
		layout: {
			config: {
				toolbar: {
					showCrumbs: false,
				}
			}
		}
	}
};

export default NoticeDetailRoute;
